/**
 * s766 (обращение техподдержки №4): сигнал входящего звонка.
 *
 * Жалоба менеджеров 10.10.2026: «непонятно, когда поступил звонок». Браузер снимает трубку сам, и
 * единственным знаком был короткий двойной тон соединения — на слух тот же, что у нового сообщения
 * (оба чистые, оба начинаются с 880 Гц). Звонок звучит иначе: две трели с дрожанием, как у
 * телефона, — его не спутать с сообщением и не пропустить, не глядя в экран.
 *
 * Сигнал играет только у менеджера, в разговор не подмешан, и короткий: клиент к этой секунде уже
 * на линии.
 */
export const TRELI_VHODYASHCHEGO = [[0, 0.42], [0.58, 0.42]] as const;
export const TON_VHODYASHCHEGO = 1568;
export const DROZH_VHODYASHCHEGO = 22;

let kontekst: AudioContext | null = null;

export function zvonokVhodyashchego(): void {
  try {
    const Konstruktor = window.AudioContext
      ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (Konstruktor === undefined) return;

    // Один контекст на вкладку: браузер ограничивает их число, а звонков за смену — сотни.
    kontekst ??= new Konstruktor();
    if (kontekst.state === 'suspended') void kontekst.resume().catch(() => undefined);

    const nachalo = kontekst.currentTime;

    for (const [sdvig, dlina] of TRELI_VHODYASHCHEGO) {
      const ton = kontekst.createOscillator();
      const drozh = kontekst.createOscillator();
      const glubina = kontekst.createGain();
      const gromkost = kontekst.createGain();

      ton.type = 'triangle';
      ton.frequency.value = TON_VHODYASHCHEGO;
      // Дрожание высоты — то, что делает трель звонком, а не тоном.
      drozh.type = 'square';
      drozh.frequency.value = DROZH_VHODYASHCHEGO;
      glubina.gain.value = 180;
      drozh.connect(glubina);
      glubina.connect(ton.frequency);

      gromkost.gain.setValueAtTime(0.0001, nachalo + sdvig);
      gromkost.gain.exponentialRampToValueAtTime(0.24, nachalo + sdvig + 0.02);
      gromkost.gain.setValueAtTime(0.24, nachalo + sdvig + dlina - 0.06);
      gromkost.gain.exponentialRampToValueAtTime(0.0001, nachalo + sdvig + dlina);

      ton.connect(gromkost);
      gromkost.connect(kontekst.destination);
      ton.start(nachalo + sdvig);
      drozh.start(nachalo + sdvig);
      ton.stop(nachalo + sdvig + dlina + 0.02);
      drozh.stop(nachalo + sdvig + dlina + 0.02);
    }
  } catch {
    // Браузер запретил звук — окно звонка всё равно всплывёт.
  }
}
